import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAll: {
    queryFn: () => useApi().permissions.getPermissions(),
    queryKey: () => ['permissions']
  }
} as const

const mutations = {} as const

export type PermissionService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): PermissionService =>
  defineService(authArgs, {
    queries,
    mutations
  })
